import { request } from '@/utils'

export default function flat(url, opt = {}) {
  return new Promise(resolve => {
    request(url, {
      ...opt,
    })
      .then(data => {
        resolve({
          data: data,
          error: null,
        })
      })
      .catch(e => {
        resolve({
          data: null,
          error: e || new Error('获取数据失败'),
        })
      })
  })
}
